import { ScheduleActivityStatusBase } from './base/schedule-activity-status-base';

export class ScheduleActivityStatus extends ScheduleActivityStatusBase { }